export const  profielBackgroundColor: string[] = [
    '#80A3DC',  // Original blue
    '#FDCD16',  // Yellow
    '#fda758',  // Orange
    '#F67EAF',  // Pink
    '#CB9AFC',  // Purple
    '#94D1BE',  // Soft Mint
    '#FF9B9B',  // Light Coral
    '#87CEEB',  // Sky Blue
    '#FFB5E8' ,   // Light Pink     
];